module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_WoodMatted_MockedUp.eeec3eec.jpg";